import { useApplicationConfigStore } from '~/store/application-config'
import { useRootStore } from '~/store/root'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const rootStore = useRootStore()

  if (!rootStore.isLoggedIn) {
    redirectToWidget(to.fullPath)
    return
  }

  const applicationConfigStore = useApplicationConfigStore()

  const { exp } = to.query
  const resumeUrl = await applicationConfigStore.getResumeApplicationData(exp);

  return navigateTo(resumeUrl)
})
